'use client';

import styled from '@emotion/styled';

import { mq } from '../../util/mediaQueries';
import type { RootLayoutProps } from './RootLayout.types';

const Container = styled.div<Pick<RootLayoutProps, 'paddingTop'>>(({ theme, paddingTop = 65 }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100%',
  backgroundColor: theme.stellenportal?.style?.backgroundColor || theme.eclipseTier2Color.surface.base,
  color: theme.stellenportal?.fontStyle?.color,
  fontFamily: theme.stellenportal?.fontStyle?.type as string | undefined,
  fontSize: theme.stellenportal?.fontStyle?.size as string | undefined,
  '& *': { fontFamily: 'inherit !important' },
  // TODO: Reference the required padding from the header
  paddingTop,
}));

const Content = styled.div({
  flex: '1 0 auto',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: 1800,
  marginInline: 'auto',
  [mq['>=md']]: {
    paddingInline: 'clamp(16px, 5vw, 20px)',
  },
});

export const S = {
  Container,
  Content,
} as const;
